export default __webpack_public_path__ + "static/HARPERS-BAZAAR_mobile@3x-771d2163e6df4f5d4a558831b2436ef4.png";